import React, { useEffect, useState } from 'react';
import { InternalApiManualAlert } from '../../api-internal';
import ManualAlerts from './ManualAlerts';
import { manualAlertInternalApi } from '../../apis';

interface AlertProps {
  transactionId: string;
  personId?: string;
  personName?: string;
  transactionAmount?: string;
}

export const TransactionManualAlerts = ({ transactionId, personId, personName, transactionAmount }: AlertProps) => {
  const [fetching, setFetching] = useState(false);
  const [alerts, setAlerts] = useState<InternalApiManualAlert[]>([]);
  const [page, setPage] = useState<number>(0);
  const size = 20;
  const [total, setTotal] = useState<number>(0);

  const fetchAlerts = async () => {
    const alertsList = await manualAlertInternalApi.getManualAlerts({
      transactionId,
      page,
      size,
    });
    setAlerts(alertsList);
    setTotal(alertsList.length);
  };

  const updateAlerts = async () => {
    setFetching(true);
    await fetchAlerts();
    setFetching(false);
  };

  useEffect(() => {
    fetchAlerts();
  }, [transactionId, page]);

  return (
    <ManualAlerts
      page={page}
      size={size}
      total={total}
      loading={fetching}
      alerts={alerts}
      expandable
      expandedByDefault={false}
      showActions={false}
      showInteractiveStatus={false}
      attributes={[
        { key: 'ID', sortable: false },
        { key: 'Object', sortable: false },
        { key: 'Rationale', sortable: false },
        { key: 'Created', sortable: false },
        { key: 'Assignee', sortable: false },
        { key: 'Status', sortable: false },
        { key: 'Actions', sortable: false },
      ]}
      onUpdate={updateAlerts}
      onUpdatePage={setPage}
      createAlertProps={
        personId
          ? {
              personId,
              transactionId,
              personName,
              transactionAmount,
            }
          : undefined
      }
    />
  );
};

export default TransactionManualAlerts;
